export default function IconVolumeOff() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 11C4 10.4477 4.44772 10 5 10H8V22H5C4.44772 22 4 21.5523 4 21V11Z" fill="currentColor" />
      <path d="M8 10L13.3492 5.41496C13.9979 4.85896 15 5.31987 15 6.17422V25.8258C15 26.6801 13.9979 27.141 13.3492 26.585L8 22V10Z"
        fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M17.3476 21.6569C17.7381 22.0474 18.3713 22.0474 18.7618 21.6569L23.0044 17.4143L27.2472 21.6571C27.6378 22.0477 28.2709 22.0477 28.6614 21.6571C29.052 21.2666 29.052 20.6334 28.6614 20.2429L24.4186 16.0001L28.6613 11.7574C29.0518 11.3669 29.0518 10.7337 28.6613 10.3432C28.2708 9.95266 27.6376 9.95266 27.2471 10.3432L23.0044 14.5859L18.7619 10.3434C18.3714 9.95289 17.7383 9.95289 17.3477 10.3434C16.9572 10.7339 16.9572 11.3671 17.3477 11.7576L21.5902 16.0001L17.3476 20.2427C16.9571 20.6332 16.9571 21.2664 17.3476 21.6569Z"
        fill="currentColor" />
    </svg>
  );
}
